export default () : number => {
    return parseInt(window.getComputedStyle(document.documentElement)
        .getPropertyValue("font-size"));
}